(() => {
  function initialize(root) {
    root.querySelectorAll('.ag-footer').forEach(footer => {
      if (footer.dataset.accordionReady) return;
      footer.dataset.accordionReady = 'true';
      const desktop = window.matchMedia('(min-width: 990px)');
      const panels = footer.querySelectorAll('.ag-footer__accordion');
      const sync = () => panels.forEach(panel => {
        panel.open = desktop.matches;
        const summary = panel.querySelector('summary');
        summary.setAttribute('aria-expanded', String(panel.open));
        summary.setAttribute('aria-disabled', String(desktop.matches));
      });
      panels.forEach((panel, index) => {
        const summary = panel.querySelector('summary');
        const content = panel.querySelector('.ag-footer__panel');
        content.id = footer.id + '-panel-' + index;
        summary.setAttribute('aria-controls', content.id);
        summary.addEventListener('click', event => { if (desktop.matches) event.preventDefault(); });
        panel.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(panel.open)));
      });
      sync();
      desktop.addEventListener('change', sync);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
